import classNames from 'classnames';
import css from './global-search.module.scss';
import List from 'src/pages/services/list';
import PaginatedFooter from 'src/components/paginated-footer/paginated-footer';
import { ServiceClasses, ServicesBlock } from 'src/types';
import { createSearchParams, useNavigate } from 'react-router-dom';

export interface SearchBlockProps {
  categoryItems: {
    items: ServicesBlock[];
    totalServicesCount: number;
  };
  icon: JSX.Element;
  className: ServiceClasses;
  search: string;
  route: {
    path: string;
    relativePath: string;
    title: string;
    meta: {
      title: string;
      description: string;
      openGraph: {
        img: string;
        type: string;
      };
    };
  };
}

function SearchServiceBlock({ categoryItems, icon, className, search, route }: Readonly<SearchBlockProps>) {
  const navigate = useNavigate();
  return (
    <div className={css.searchResultsGroup}>
      <div className={classNames(css.header, css[className])}>
        <div className={css.icon}>{icon}</div>
        <p>{route.title}</p>
      </div>
      <List servicesLimit={3} servicesBlocks={categoryItems.items} className={className} showCardsPagination={false} />
      {categoryItems.totalServicesCount >= 3 && (
        <PaginatedFooter
          caption={`Дивитися всі: ${categoryItems.totalServicesCount}`}
          onClick={() =>
            navigate({
              pathname: route.path,
              search: createSearchParams({
                search: search
              }).toString()
            })
          }
        />
      )}
    </div>
  );
}

export default SearchServiceBlock;
